import { render } from "./WuerfeltoolTab.vue?vue&type=template&id=3b9a7e8f"
import script from "./WuerfeltoolTab.vue?vue&type=script&lang=js"
export * from "./WuerfeltoolTab.vue?vue&type=script&lang=js"

import "./WuerfeltoolTab.vue?vue&type=style&index=0&id=3b9a7e8f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__